import styled from "styled-components";

export const HorizontalRule = styled.div<{
  variant?: "primary" | "secondary" | "headline";
  side?: "center" | "left" | "right";
}>`
  clear: both;
  height: 1px;
  width: 50%;
  margin: var(--spacing-lg) 0;
  ${(p) =>
    p.side === "left"
      ? "float: left"
      : p.side === "right"
      ? "float: right"
      : ""};

  background: ${(p) =>
    p.variant === "primary"
      ? "var(--primary-horizontal-gradient)"
      : p.variant === "headline"
      ? "var(--highlight-hr-color)"
      : "var(--secondary-hr-color)"};
`;
